import * as React from 'react';
import styled from 'styled-components';

import { Alert, AlertProps, AlertSize } from '@creditornot/cb-alert';

import { parseError } from '../../utils/errorUtils';

const StyledAlert = styled(Alert)`
  overflow-wrap: break-word;
  white-space: pre-wrap;
`;

type Props = {
  error: Error | null;
  size?: AlertSize;
  className?: string;
  onClose?: AlertProps['onCloseButtonClick'];
};

export const ApiErrorNotification: React.FC<Props> = ({ error, size, className, onClose }) => {
  const [message, setMessage] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (error) {
      parseError(error).then(setMessage).catch(console.error);
    } else {
      setMessage(null);
    }
  }, [error]);

  if (!error) return null;

  return (
    <StyledAlert variant="error" size={size} className={className} onCloseButtonClick={onClose}>
      {message}
    </StyledAlert>
  );
};
